import { Suspense, useSyncExternalStore } from "react";

import QueryProvider from "@providers/query-provider";
import UserProvider from "@providers/user-provider";
import { Route, Router, MissingBoundary } from "@router/router";
import AlertContainer from "@utils/alert/container";
import i18n from "@utils/i18n";

import "./app.styl";
import Page404 from "./pages/404";
import LoadingPage from "./pages/loading";
import routes from "./routes";

const subscribeToLanguage = (listener: () => void) => {
  i18n.on("languageChanged", listener);
  return () => i18n.off("languageChanged", listener);
};

const getCurrentLanguage = () => i18n.language;

const App = () => {
  useSyncExternalStore(subscribeToLanguage, getCurrentLanguage);

  return (
    <>
      <Suspense fallback={<LoadingPage />}>
        <AlertContainer />
        <QueryProvider>
          <UserProvider>
            <Router routes={routes}>
              <MissingBoundary fallback={() => <Page404 />}>
                <Route />
              </MissingBoundary>
            </Router>
          </UserProvider>
        </QueryProvider>
      </Suspense>
    </>
  );
};

export default App;
